export const formatInTwoDigits = (num: number) => ('0' + num).slice(-2);

export const hasDays = (time: number) => Math.abs(time) > 24 * 60 * 60 * 1000;
export const getDays = (time: number) => Math.floor(Math.abs(time) / (24 * 60 * 60 * 1000)).toString();

export const hasHours = (time: number) => Math.abs(time) > 60 * 60 * 1000;
export const getHours = (time: number) => formatInTwoDigits(Math.floor((Math.abs(time) % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)));

export const hasMinutes = (time: number) => Math.abs(time) > 60 * 1000;
export const getMinutes = (time: number) => formatInTwoDigits(Math.floor((Math.abs(time) % (60 * 60 * 1000)) / (60 * 1000)));

export const hasSeconds = (time: number) => Math.abs(time) > 1000;
export const getSeconds = (time: number) => formatInTwoDigits(Math.floor((Math.abs(time) % (60 * 1000)) / 1000));
